import React, { useEffect, useState } from 'react'
import { getImages } from '../Const'
const WebAppointmentsTable = ({ leadAction, leadData, completedLead }) => {
    const [visibleData, setVisibleData] = useState([]);
    const [limit, setLimit] = useState(10);
    const [blankDateData, setBlankDateData] = useState([]);
    useEffect(() => {
        const withDate = leadData
            .filter(item => !item.appointment_passed)
            .sort((a, b) => new Date(b.appointment_date_obj) - new Date(a.appointment_date_obj));
        const withoutDate = leadData.filter(item => item.appointment_passed );

        setVisibleData(withDate.slice(0, limit));
        setBlankDateData(withoutDate); // Show all with no appointment date later
        // setBlankDateData(withoutDate); // Show all with no appointment date later

        console.log(leadData,withDate,withoutDate);
    }, [leadData, limit]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.innerHeight + window.scrollY;
            const bottomPosition = document.documentElement.offsetHeight;
            if (scrollPosition >= bottomPosition - 300) {
                setLimit(prev => (prev + 10 > leadData.length ? leadData.length : prev + 10));
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [leadData]);
    // console.log("WebAppointments leadData", leadData)
    // console.log("WebAppointments blankDateData", blankDateData)
    return (
        <>
            <div className='cqr-table wat-table'>
                <table className='w-100'>
                    {/* {console.log("visibleData", visibleData)} */}
                    {(visibleData.length > 0 || blankDateData.length > 0) ? (
                        <tbody>
                            {blankDateData.length > 0 && (
                                <>
                                    <tr className="date-group-header">
                                        <td colSpan="100%" className="text-start fw-bold p-2 pt-0">
                                            <div className='d-flex align-items-center wat-date-block'>
                                                <div className='d-flex align-items-center justify-content-center wat-date-box me-4'>
                                                    <span className='wat-icon'><img src={getImages('red-calender-icon.png')} /></span>
                                                </div>
                                                <span className='wat-day'>No Shows </span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Time</th>
                                        <th>ID</th>
                                        <th>Customer Name</th>
                                        {completedLead && <th>&nbsp;</th>}
                                        <th>Vehicle Info</th>
                                        <th>Location</th>
                                        {completedLead ?
                                            <th className='text-center'>Created by / <br />Status</th>
                                            : <th className='text-center'>Created by</th>
                                        }
                                        <th className='text-center'>Details</th>
                                    </tr>
                                    {blankDateData.map((item, index) => (
                                        <tr key={index} className={index % 2 === 0 ? 'even' : 'odd'}>
                                            <td className='cursor-pointer text-start text-blue' onClick={() => leadAction(item)}>
                                                <span className='ps-3 d-inline-block'>
                                                    {item.appointment_date_obj
                                                        ? new Date(item.appointment_date_obj).toLocaleString([], {
                                                             month: '2-digit', day: '2-digit'
                                                        })
                                                        : '--'
                                                    }
                                                </span>
                                            </td>
                                            <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                                {item.lead_id}
                                            </td>
                                            <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                                {item.full_name}
                                            </td>
                                            {completedLead && (
                                                <td>
                                                    {(() => {
                                                        const badgeNumber = Math.floor(Math.random() * 5) + 1;
                                                        const badgeImage = Math.random() < 0.5
                                                            ? 'icon-badge-silver.png'
                                                            : 'icon-badge-gold.png';
                                                        const textColor = badgeImage === 'icon-badge-silver.png' ? '#fff' : '#333';

                                                        return (
                                                            <span
                                                                className="icon-badge"
                                                                style={{
                                                                    background: `url(${getImages(badgeImage)})`,
                                                                    color: textColor
                                                                }}
                                                            >
                                                                {badgeNumber}
                                                            </span>
                                                        );
                                                    })()}
                                                </td>
                                            )}
                                            <td className='cursor-pointer text-blue' onClick={() => leadAction(item)}>
                                                {item.vehicle_name}
                                            </td>
                                            <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                                {item.location}
                                            </td>
                                            <td className='cursor-pointer text-center' onClick={() => leadAction(item)}>
                                                Office <br />
                                                {completedLead && item.status}
                                            </td>
                                            <td className="cursor-pointer text-center" onClick={() => leadAction(item)}>
                                                <img src={getImages("search.png")} alt="Search" />
                                            </td>
                                        </tr>
                                    ))}
                                </>
                            )}
                            {(() => {
                                const groupedData = visibleData.reduce((acc, item) => {
                                    const appointmentDate = item.appointment_date_obj
                                        ? new Date(item.appointment_date_obj)
                                        : null;

                                    // If there's no date, assign to a default group
                                    if (!appointmentDate) {
                                        if (!acc['No appointment Date']) acc['No appointment Date'] = { weekday: '', month: '', day: '', items: [] };
                                        acc['No appointment Date'].items.push(item);
                                        return acc;
                                    }

                                    // Extract separate keys
                                    const weekday = appointmentDate.toLocaleDateString('en-US', { weekday: 'long' });
                                    const month = appointmentDate.toLocaleDateString('en-US', { month: 'long' });
                                    const day = appointmentDate.toLocaleDateString('en-US', { day: 'numeric' });

                                    // Use a composite key for grouping
                                    const groupKey = `${weekday}-${month}-${day}`;

                                    if (!acc[groupKey]) acc[groupKey] = { weekday, month, day, items: [] };
                                    acc[groupKey].items.push(item);

                                    return acc;
                                }, {});
                                // Prepare "Today" and "Tomorrow" keys
                                const today = new Date();
                                const tomorrow = new Date();
                                tomorrow.setDate(today.getDate() + 1);

                                const formatGroupKey = (date) => {
                                    const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
                                    const month = date.toLocaleDateString('en-US', { month: 'long' });
                                    const day = date.toLocaleDateString('en-US', { day: 'numeric' });
                                    return `${weekday}-${month}-${day}`;
                                };

                                const todayKey = formatGroupKey(today);
                                const tomorrowKey = formatGroupKey(tomorrow);

                                // Get today
                                today.setHours(0, 0, 0, 0);

                                // Extract dates from keys and map to array with date
                                const entriesWithDates = Object.entries(groupedData).map(([key, group]) => {
                                    const date = new Date(`${group.month} ${group.day}, ${new Date().getFullYear()}`);
                                    date.setHours(0, 0, 0, 0);
                                    return { key, group, date };
                                });

                                // Find next upcoming date after today
                                const futureDates = entriesWithDates
                                    .filter(({ date }) => date > today)
                                    .sort((a, b) => a.date - b.date);

                                const nextUpcoming = futureDates.length > 0 ? futureDates[0].key : null;

                                // Sort final entries
                                const sortedEntries = entriesWithDates.sort((a, b) => {
                                    // Priority 1: today
                                    if (a.key === todayKey) return -1;
                                    if (b.key === todayKey) return 1;

                                    // Priority 2: next upcoming
                                    if (a.key === nextUpcoming) return -1;
                                    if (b.key === nextUpcoming) return 1;

                                    // If both future
                                    if (a.date >= today && b.date >= today) {
                                        return a.date - b.date;
                                    }

                                    // If both past
                                    if (a.date < today && b.date < today) {
                                        return b.date - a.date;
                                    }

                                    // Put future before past
                                    return a.date >= today ? -1 : 1;
                                });


                                return sortedEntries.map(({ key: groupKey, group }) => {
                                    const { weekday, month, day, items } = group;

                                    return (
                                        <React.Fragment key={groupKey}>
                                            <tr className="date-group-header">
                                                <td colSpan="100%" className="text-start fw-bold p-2 pt-4 ps-0">
                                                    <div className='d-flex align-items-center wat-date-block'>
                                                        <div className='d-flex align-items-center wat-date-box me-4'>
                                                            <span className='wat-month me-2'>{month}</span>
                                                            <span className='wat-date'>{day}</span>
                                                        </div>
                                                        <span className='wat-day'>{weekday} </span>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>Time</th>
                                                <th>ID</th>
                                                <th>Customer Name</th>
                                                {completedLead && <th>&nbsp;</th>}
                                                <th>Vehicle Info</th>
                                                <th>Location</th>
                                                {completedLead ?
                                                    <th className='text-center'>Created by / <br />Status</th>
                                                    : <th className='text-center'>Created by</th>
                                                }
                                                {/* {completedLead ?
                                                    <th className='text-center'>COMPLETED / <br />EXPIRATION</th>
                                                    : <th className='text-center'>COMPLETED</th>
                                                } */}
                                                <th className='text-center'>Details</th>
                                            </tr>
                                            {items.map((item, index) => (
                                                <tr key={index} className={index % 2 === 0 ? 'even' : 'odd'}>
                                                    <td className='cursor-pointer text-start text-blue' onClick={() => leadAction(item)}>
                                                        {item.appointment_date_obj
                                                            ? new Date(item.appointment_date_obj).toLocaleTimeString([], {
                                                                hour: '2-digit',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            })
                                                            : '--'}
                                                    </td>
                                                    <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                                        {item.lead_id}
                                                    </td>
                                                    <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                                        {item.full_name}
                                                    </td>
                                                    {completedLead && (
                                                        <td>
                                                            {(() => {
                                                                const badgeNumber = Math.floor(Math.random() * 5) + 1;
                                                                const badgeImage = Math.random() < 0.5
                                                                    ? 'icon-badge-silver.png'
                                                                    : 'icon-badge-gold.png';
                                                                const textColor = badgeImage === 'icon-badge-silver.png' ? '#fff' : '#333';

                                                                return (
                                                                    <span
                                                                        className="icon-badge"
                                                                        style={{
                                                                            background: `url(${getImages(badgeImage)})`,
                                                                            color: textColor
                                                                        }}
                                                                    >
                                                                        {badgeNumber}
                                                                    </span>
                                                                );
                                                            })()}
                                                        </td>
                                                    )}
                                                    <td className='cursor-pointer text-blue' onClick={() => leadAction(item)}>
                                                        {item.vehicle_name}
                                                    </td>
                                                    <td className='cursor-pointer' onClick={() => leadAction(item)}>
                                                        {item.location}
                                                    </td>
                                                    <td className='cursor-pointer text-center' onClick={() => leadAction(item)}>
                                                        Office <br />
                                                        {completedLead && item.status}
                                                    </td>
                                                    <td className="cursor-pointer text-center" onClick={() => leadAction(item)}>
                                                        <img src={getImages("search.png")} alt="Search" />
                                                    </td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    );
                                });
                            })()}
                        </tbody>


                    ) : (
                        <tbody>
                            <tr>
                                <td className="text-center" colSpan="7">Total Items: 0</td>
                            </tr>
                        </tbody>
                    )}

                </table>
            </div>
        </>
    )
}

export default WebAppointmentsTable